import { RecentDataRepo } from "@app/core/recent-data/domain/recent-data.repo";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { RecentDataWS } from "../network/recent-data.ws";
import { Statistic } from "@app/core/statistics/domain/model/statistic";
import { RecentData } from "../../domain/model/recent-data";

@Injectable()
export class GetRecentDataDataRepo implements RecentDataRepo {
  constructor(
    private recentDataWS: RecentDataWS,
  ) {}
  getRecentData(
    club_limit: number,
    token: string
  ): Observable<RecentData> {
    return this.recentDataWS.execute(club_limit, token);
  }
}
